export const AW_EXPOSURE_SEARCH_API_URL = process.env?.AWAPI_AWEXPOSURESEARCH_URL || '/awexposuresearch';
